import { Injectable } from '@angular/core';

export enum SilaCoreConfigMode {
    CLIENT, UNITELABS
}
export interface SilaCoreConfigInterface {
    mode: SilaCoreConfigMode | null;
}

/**
 *    Class AppConfig
 *
 *    This class is responsible for getting all settings from REST
 *    right before boot. If config requests error, then we proceed
 *    with defaults.
 */
@Injectable()
export class SilaCoreConfig {

    private static config: SilaCoreConfigInterface = { mode: null };

    /**
     * AppConfig constructor (angular injects auto-magically for us)
     * param {HttpClient} http
     */
    public static setConfig(config: SilaCoreConfigInterface) {
        SilaCoreConfig.config = config;
    }

    public static getMode(): SilaCoreConfigMode {
        return this.config.mode || SilaCoreConfigMode.UNITELABS;
    }
}

